import React from "react";
import "./adminDashboard.css";

export default function StatCard({ title, value, trend, trendDirection = "neutral", icon }) {
  const trendClass =
    trendDirection === "up" ? "adminTrendUp" : trendDirection === "down" ? "adminTrendDown" : "adminTrendNeutral";

  return (
    <div className="adminCard adminStatCard">
      <div className="adminStatTop">
        <div className="adminStatMeta">
          <div className="adminStatTitle">{title}</div>
          <div className="adminStatValue">{value}</div>
        </div>
        <div className="adminStatIcon" aria-hidden="true">
          {icon}
        </div>
      </div>
      <div className={`adminStatTrend ${trendClass}`}>{trend}</div>
    </div>
  );
}

